/**
 * BriqueChart의 Min, Max 관련 기능 구현
 */

import BriqueChart from './BriqueChart.vue'

export default {
  /**
   * traces로부터 X축의 Min, Max를 구해서 차트에 적용한다.
   * @param {Object} element Chart의 Element
   * @param {Array} traces 차트의 데이터
   * @param {Object} layout 차트의 Layout, Optional, 이값이 없으면 element에서 구해서 사용한다.
   * @param {Boolean} isApplyInChart Min/Max를 차트에 적용할지 여부
   * @returns
   */
  setXMinMax (element, traces, layout, isApplyInChart = false) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)
    if (_.isUndefined(layout)) layout = element.layout

    let briqueChartData = element.briqueChartData
    let briqueChartOption = element.briqueChartOption

    if (!_.isEmpty(layout.xaxis.range) && !layout.xaxis.range.length > 1) {
      briqueChartData.xMinForPad = layout.xaxis.range[0]
      briqueChartData.xMaxForPad = layout.xaxis.range[layout.xaxis.range.length - 1]
      return
    }

    layout.xaxis = layout.xaxis || {}

    let mins = []
    let maxs = []
    for (let trace of traces) {
      mins.push(_.min(trace.x))
      maxs.push(_.max(trace.x))
    }

    let min = _.min(mins)
    let max = _.max(maxs)

    if (min === Number.NEGATIVE_INFINITY) min = Number.MIN_VALUE
    if (max === Number.POSITIVE_INFINITY) max = Number.MAX_VALUE

    let { min: shapeMin, max: shapeMax } = BriqueChart.getShapeXMinMax(layout)
    let isApplyShape = !!((!_.isUndefined(shapeMin) && min > shapeMin) || (!_.isUndefined(shapeMax) && max < shapeMax))
    if (isApplyShape) {
      if (!_.isUndefined(shapeMin) && min > shapeMin) min = shapeMin
      if (!_.isUndefined(shapeMax) && max < shapeMax) max = shapeMax
    }

    let minForPad = min - ((max - min) * briqueChartOption.xaxis.min.rate)
    let maxForPad = max + (max - min) * briqueChartOption.xaxis.max.rate

    if (minForPad === Number.NEGATIVE_INFINITY) minForPad = Number.MIN_VALUE
    if (maxForPad === Number.POSITIVE_INFINITY) maxForPad = Number.MAX_VALUE

    if (isApplyShape || isApplyInChart) {
      layout.xaxis.range = [minForPad, maxForPad]
    }

    // console.log(maxForPad)

    briqueChartData.xMin = min
    briqueChartData.xMax = max

    briqueChartData.xMinForPad = minForPad
    briqueChartData.xMaxForPad = maxForPad
  },

  /**
   * traces로부터 Y축의 Min, Max를 구해서 차트에 적용햔다.
   * @param {Object} element Chart의 Element
   * @param {Array} traces 차트의 데이터
   * @param {Object} layout 차트의 Layout, Optional, 이값이 없으면 element에서 구해서 사용한다.
   * @returns
   */
  setYMinMax (element, traces, layout) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)
    if (_.isUndefined(layout)) layout = element.layout

    let briqueChartData = element.briqueChartData
    let briqueChartOption = element.briqueChartOption

    if (!_.isEmpty(layout.yaxis.range) && !layout.yaxis.range.length > 1) {
      briqueChartData.yMinForPad = layout.yaxis.range[0]
      briqueChartData.yMaxForPad = layout.yaxis.range[layout.yaxis.range.length - 1]
      return
    }

    layout.yaxis = layout.yaxis || {}

    let mins = []
    let maxs = []
    for (let trace of traces) {
      if (_.isEmpty(trace.y)) continue
      let ys = trace.y.filter(v => v !== 'NaN')
      mins.push(_.min(ys))
      maxs.push(_.max(ys))
    }

    let min = _.min(mins)
    let max = _.max(maxs)

    if (min === Number.NEGATIVE_INFINITY) min = Number.MIN_VALUE
    if (max === Number.POSITIVE_INFINITY) max = Number.MAX_VALUE

    let { min: shapeMin, max: shapeMax } = BriqueChart.getShapeYMinMax(layout)
    let isApplyShape = !!((!_.isUndefined(shapeMin) && min > shapeMin) || (!_.isUndefined(shapeMax) && max < shapeMax))
    if (isApplyShape) {
      if (!_.isUndefined(shapeMin) && min > shapeMin) min = shapeMin
      if (!_.isUndefined(shapeMax) && max < shapeMax) max = shapeMax
    }

    let minForPad = min - ((max - min) * briqueChartOption.yaxis.min.rate)
    let maxForPad = max + (max - min) * briqueChartOption.yaxis.max.rate

    if (minForPad === Number.NEGATIVE_INFINITY) minForPad = Number.MIN_VALUE
    if (maxForPad === Number.POSITIVE_INFINITY) maxForPad = Number.MAX_VALUE

    layout.yaxis.range = [minForPad, maxForPad]

    briqueChartData.yMin = min
    briqueChartData.yMax = max

    briqueChartData.yMinForPad = minForPad
    briqueChartData.yMaxForPad = maxForPad
  },

  /**
   * 기존 데이터와 추가된 데이터를 이용하여 X축의 Min, Max를 구해서 차트에 적용한다.
   * @param {Object} element Chart의 Element
   * @param {Object} addData 추가 데이터
   * @param {Object} isApplyInChart X축 Min, Max값을 차트에 적용할지 여부
   * @returns
   */
  setXMinMaxForExtendTraces (element, addData, isApplyInChart = true) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)
    let layout = element.layout

    let briqueChartData = element.briqueChartData
    // let briqueChartOption = element.briqueChartOption

    let flatX = _.flatMap(addData.x).map((v) => parseFloat(v))
    let min = _.min(flatX)
    let max = _.max(flatX)

    min = _.min([min, briqueChartData.xMin])
    max = _.max([max, briqueChartData.xMax])

    if (min === Number.NEGATIVE_INFINITY) min = Number.MIN_VALUE
    if (max === Number.POSITIVE_INFINITY) max = Number.MAX_VALUE

    // let minForPad = min - ((max - min) * briqueChartOption.xaxis.min.rate)
    // let maxForPad = max + (max - min) * briqueChartOption.xaxis.max.rate

    let minForPad = min
    let maxForPad = max

    if (minForPad === Number.NEGATIVE_INFINITY) minForPad = Number.MIN_VALUE
    if (maxForPad === Number.POSITIVE_INFINITY) maxForPad = Number.MAX_VALUE

    if (isApplyInChart) layout.xaxis.range = [minForPad, maxForPad]

    briqueChartData.xMin = min
    briqueChartData.xMax = max

    briqueChartData.xMinForPad = minForPad
    briqueChartData.xMaxForPad = maxForPad
  },

  /**
   * 기존 데이터와 추가된 데이터를 이용하여 Y축의 Min, Max를 구해서 차트에 적용한다.
   * @param {Object} element Chart의 Element
   * @param {Array} traces 차트의 데이터
   * @param {Object} layout 차트의 Layout, Optional, 이값이 없으면 element에서 구해서 사용한다.
   * @returns
   */
  setYMinMaxForExtendTraces (element, addData, isApplyInChart = true) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)
    let layout = element.layout

    let briqueChartData = element.briqueChartData
    let briqueChartOption = element.briqueChartOption

    let flatY = _.flatMap(addData.y).map((v) => parseFloat(v))
    let min = _.min(flatY)
    let max = _.max(flatY)

    min = _.min([min, briqueChartData.yMin])
    max = _.max([max, briqueChartData.yMax])

    if (min === Number.NEGATIVE_INFINITY) min = Number.MIN_VALUE
    if (max === Number.POSITIVE_INFINITY) max = Number.MAX_VALUE

    let minForPad = min - ((max - min) * briqueChartOption.yaxis.min.rate)
    let maxForPad = max + ((max - min) * briqueChartOption.yaxis.max.rate)

    if (minForPad === Number.NEGATIVE_INFINITY) minForPad = Number.MIN_VALUE
    if (maxForPad === Number.POSITIVE_INFINITY) maxForPad = Number.MAX_VALUE

    if (isApplyInChart) layout.yaxis.range = [minForPad, maxForPad]

    briqueChartData.yMin = min
    briqueChartData.yMax = max

    briqueChartData.yMinForPad = minForPad
    briqueChartData.yMaxForPad = maxForPad
  },

  /**
   * 도형이 있을 경우 X축의 Min/Max를 구하여 리턴한다.
   * @param {Object} layout Chart의 Layout
   * @returns min, max 값
   */
  getShapeXMinMax (layout) {
    let min, max
    if (_.isUndefined(layout.shapes)) return { min, max }

    for (let shape of layout.shapes) {
      switch (shape.type) {
        case 'circle':
        case 'rect':
        case 'line':
          min = _.min([min, shape.x0, shape.x1])
          max = _.max([max, shape.x0, shape.x1])
          break
        case 'path':
          // Quadratic Bezier Curves : M 4,4 Q 6,0 8,4
          // Cubic Bezier Curves : M 1,4 C 2,8 6,4 8,8
          // Filled Triangle : M 1 1 L 1 3 L 4 1 Z
          // Filled Polygon : M 3,7 L2,8 L2,9 L3,10, L4,10 L5,9 L5,8 L4,7 Z

          let xysss = shape.path.split(/[MZQCML]/)// ["", "1,4", "2,8 6,4 8,8"]
          for (let xyss of xysss) {
            if (_.isEmpty(xyss.trim())) continue
            let xys = xyss.trim().split(/[, ]/)// ["2", "8", "6", "4", "8", "8"]
            let xs = xys.filter((v, i) => i % 2 === 0).map((v) => parseFloat(v))// X값만 추출 [2, 6, 8]

            if (xs.length === 0) continue

            if (min !== undefined) xs.push(min)
            if (max !== undefined) xs.push(max)

            min = _.min(xs)
            max = _.max(xs)
          }

          break
      }
    }

    return { min, max }
  },

  /**
   * 도형이 있을 경우 Y축의 Min/Max 를 구하여 리턴한다.
   * @param {Object} layout Chart의 Layout
   * @returns min, max 값
   */
  getShapeYMinMax (layout) {
    let min, max
    if (_.isUndefined(layout.shapes)) return { min, max }

    for (let shape of layout.shapes) {
      switch (shape.type) {
        case 'circle':
        case 'rect':
        case 'line':
          min = _.min([min, shape.y0, shape.y1])
          max = _.max([max, shape.y0, shape.y1])
          break
        case 'path':
          // Quadratic Bezier Curves : M 4,4 Q 6,0 8,4
          // Cubic Bezier Curves : M 1,4 C 2,8 6,4 8,8
          // Filled Triangle : M 1 1 L 1 3 L 4 1 Z
          // Filled Polygon : M 3,7 L2,8 L2,9 L3,10, L4,10 L5,9 L5,8 L4,7 Z

          let xysss = shape.path.split(/[MZQCML]/)// ["", "1,4", "2,8 6,4 8,8"]
          for (let xyss of xysss) {
            if (_.isEmpty(xyss.trim())) continue
            let xys = xyss.trim().split(/[, ]/)// ["2", "8", "6", "4", "8", "8"]
            let ys = xys.filter((v, i) => i % 2 === 0).map((v) => parseFloat(v))// X값만 추출 [8, 4, 8]

            if (ys.length === 0) continue

            if (min !== undefined) ys.push(min)
            if (max !== undefined) ys.push(max)

            min = _.min(ys)
            max = _.max(ys)
          }

          break
      }
    }

    return { min, max }
  }
}
